


import TopBar from '@/shared/components/TopBar.component.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import Btn, { BtnColor, BtnWidth } from '@/shared/components/btn.component.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        TopBar,
        TopModal,
        Btn,
    },
})

export default class TopBarPartial extends Vue {
  private btnWidth = BtnWidth;
  private btnColor = BtnColor;
  private modalTopOpened = false;

  private openModalTop() {
    this.modalTopOpened = true;
  }

  private closeModalTop() {
    this.modalTopOpened = false;
  }

  private buttonClick() {
    //
  }
}

